<template>
  <div class="standard-why-choose-us">
    <section>
      <v-container>
        <div class="text-center" data-aos="fade-up">
          <div class="section-subtitle">
            <span class="subtitle-line"></span>
            <span class="section-title">WHY CHOOSE US</span>
            <span class="subtitle-line"></span>
          </div>
          <p class="section-description">
            Experience excellence with OH.YES — Your trusted partner
          </p>
        </div>

        <v-row class="benefits-grid-row">
          <v-col
            v-for="(benefit, index) in benefits"
            :key="benefit.title"
            cols="12"
            md="4"
            sm="6"
            :data-aos="index % 2 === 0 ? 'fade-up' : 'fade-down'"
            :data-aos-delay="index * 100"
          >
            <v-card class="standard-benefit-card elevation-2 pa-8 fill-height">
              <div class="standard-icon-wrapper mb-5">
                <v-icon size="36" color="white" class="icon-primary">{{
                  benefit.icon
                }}</v-icon>
              </div>

              <h3 class="">
                {{ benefit.title }}
              </h3>
              <p class="benefit-description">
                {{ benefit.description }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
// The script remains the same, as the data structure is fine.
export default {
  name: "WhyChooseUsStandard",
  data() {
    return {
      // Removed activeBenefit as complex hover animations are removed
      benefits: [
        {
          icon: "mdi-cash-multiple",
          title: "Cost-Effective Solutions",
          description:
            "Premium quality services at competitive prices. Save more while getting the best value for your money.",
        },
        {
          icon: "mdi-account-star",
          title: "Expert Professionals",
          description:
            "Certified and experienced technicians who deliver exceptional results every single time.",
        },
        {
          icon: "mdi-clock-fast",
          title: "Quick Response Time",
          description:
            "Lightning-fast service with same-day availability. We're there when you need us most.",
        },
        {
          icon: "mdi-shield-check",
          title: "100% Satisfaction Guaranteed",
          description:
            "Your happiness is our priority. We stand behind our work with a complete satisfaction guarantee.",
        },
        {
          icon: "mdi-calendar-check",
          title: "24/7 Availability",
          description:
            "Round-the-clock support and emergency services. Book anytime, anywhere at your convenience.",
        },
        {
          icon: "mdi-tools",
          title: "Comprehensive Services",
          description:
            "All-in-one solution for maintenance, repairs, and facility management under one roof.",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* SECTION HEADER */
.section-overline {
  color: #f46523; /* Accent color */
  letter-spacing: 2px;
}

.section-title {
  color: #1a1a1a;
  font-size: 2.5rem !important; /* Vuetify display-1 sets the size */
}

.section-description {
  color: #6c757d;
  font-size: 1.1rem;
}

/* BENEFIT CARDS */
.standard-benefit-card {
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  border-radius: 12px;
}

.standard-benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}

/* Icon Styling */
.standard-icon-wrapper {
  display: inline-flex;
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  background-color: #f46523; /* Accent color background */
  border-radius: 10px; /* Squarish/modern icon shape */
}

/* If you use small images instead of icons: */
/*
.standard-icon-wrapper img {
  width: 36px;
  height: 36px;
}
*/

.benefit-description {
  color: #495057;
  line-height: 1.6;
}

/* CTA SECTION */
.standard-cta-section {
  background-color: #1a1a1a; /* Dark background for high contrast */
  color: white;
  border-radius: 15px;
}

.cta-title {
  color: white;
  font-size: 2rem !important;
}

.cta-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
}

.cta-button {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
  letter-spacing: 1px;
}

.section-subtitle {
  color: #1a1a1a;
  font-weight: 800;
  letter-spacing: 5px;
  font-size: 13px;
  text-transform: uppercase;
  margin-top: 50px;
  display: inline-flex;
  align-items: center;
  gap: 15px;
  position: relative;
  z-index: 1;
}

.subtitle-line {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #f46523, transparent);
  display: inline-block;
  animation: lineGrow 2s infinite ease-in-out;
}

@keyframes lineGrow {
  0%,
  100% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(1.5);
  }
}

.section-title {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 900;
  padding-bottom: 10px;
  color: #f46523;
  position: relative;
  z-index: 1;
}

.section-description {
  color: black;
  font-size: 18px;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.8s ease-out 0.3s backwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
